var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9271_2415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9271_2415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.14162 16.1827L1.27979 11.3208L2.25989 10.3548L6.15572 14.2506L6.47307 13.9333L7.43905 14.8993L6.14162 16.1827ZM11.3208 16.1827L6.45895 11.3208L7.42496 10.3407L11.3208 14.2366L19.7541 5.80322L20.7201 6.78332L11.3208 16.1827ZM11.0035 11.3208L10.0234 10.3548L14.5609 5.81732L15.541 6.78332L11.0035 11.3208Z",
    fill: "#7EB66B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.dc35c27fb677fd1ae92e1f70fa44a10d.svg";
export { ForwardRef as ReactComponent };